"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMemoizedArray = void 0;
var react_1 = require("react");
var useMemoizedArray = function (externalArray) {
    var prevArrayRef = react_1.useRef(externalArray);
    var array = react_1.useMemo(function () {
        if (prevArrayRef.current === externalArray)
            return prevArrayRef.current;
        if (prevArrayRef.current.length !== externalArray.length) {
            prevArrayRef.current = externalArray;
            return externalArray;
        }
        for (var i = 0; i < externalArray.length; i += 1) {
            if (externalArray[i] !== prevArrayRef.current[i]) {
                prevArrayRef.current = externalArray;
                return externalArray;
            }
        }
        return prevArrayRef.current;
    }, [externalArray]);
    return array;
};
exports.useMemoizedArray = useMemoizedArray;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTWVtb2l6ZWRBcnJheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VNZW1vaXplZEFycmF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtCQUF3QztBQUVqQyxJQUFNLGdCQUFnQixHQUFHLFVBQTRCLGFBQWtCO0lBQzVFLElBQU0sWUFBWSxHQUFHLGNBQU0sQ0FBQyxhQUFhLENBQUMsQ0FBQztJQUMzQyxJQUFNLEtBQUssR0FBRyxlQUFPLENBQUM7UUFDcEIsSUFBSSxZQUFZLENBQUMsT0FBTyxLQUFLLGFBQWE7WUFBRSxPQUFPLFlBQVksQ0FBQyxPQUFPLENBQUM7UUFFeEUsSUFBSSxZQUFZLENBQUMsT0FBTyxDQUFDLE1BQU0sS0FBSyxhQUFhLENBQUMsTUFBTSxFQUFFO1lBQ3hELFlBQVksQ0FBQyxPQUFPLEdBQUcsYUFBYSxDQUFDO1lBQ3JDLE9BQU8sYUFBYSxDQUFDO1NBQ3RCO1FBRUQsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLGFBQWEsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUNoRCxJQUFJLGFBQWEsQ0FBQyxDQUFDLENBQUMsS0FBSyxZQUFZLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFO2dCQUNoRCxZQUFZLENBQUMsT0FBTyxHQUFHLGFBQWEsQ0FBQztnQkFDckMsT0FBTyxhQUFhLENBQUM7YUFDdEI7U0FDRjtRQUVELE9BQU8sWUFBWSxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDLEVBQUUsQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFDO0lBRXBCLE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBckJXLFFBQUEsZ0JBQWdCLG9CQXFCM0IifQ==